const BORROWER_LOAN_ORIGINATION = {
  APPLICATION_SUBMITTED: "APPLICATION_SUBMITTED",
};

export default BORROWER_LOAN_ORIGINATION;

